"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _UUID = _interopRequireDefault(require("../UUID"));

var _beedle = _interopRequireDefault(require("beedle"));

var _requests = require("./requests");

var _saveUrl;

var _onPost;

var _onLoad;

var store = new _beedle["default"]({
  actions: {
    setData: function setData(context, data, saveData) {
      context.commit('setData', data);
      if (saveData) this.save(data);
    },
    load: function load(context, _ref) {
      var _this = this;

      var loadUrl = _ref.loadUrl,
          saveUrl = _ref.saveUrl,
          data = _ref.data,
          saveAlways = _ref.saveAlways;
      _saveUrl = saveUrl;
      var saveA = saveAlways || saveAlways === undefined;
      context.commit('setSaveAlways', saveA);

      if (_onLoad) {
        _onLoad().then(function (x) {
          if (data && data.length > 0 && x.length === 0) {
            data.forEach(function (y) {
              return x.push(y);
            });
          }

          _this.setData(context, x);
        });
      } else if (loadUrl) {
        (0, _requests.get)(loadUrl).then(function (x) {
          if (data && data.length > 0 && x.length === 0) {
            data.forEach(function (y) {
              return x.push(y);
            });
          }

          _this.setData(context, x);
        });
      } else {
        this.setData(context, data);
      }
    },
    create: function create(context, element) {
      var _context$state = context.state,
          data = _context$state.data,
          saveAlways = _context$state.saveAlways;
      data.push(element);
      this.setData(context, data, saveAlways);
    },
    "delete": function _delete(context, element) {
      var _context$state2 = context.state,
          data = _context$state2.data,
          saveAlways = _context$state2.saveAlways;
      data.splice(data.indexOf(element), 1);
      this.setData(context, data, saveAlways);
    },
    "clone": function clone(context, element) {
      var _context$state = context.state,
          data = _context$state.data,
          saveAlways = _context$state.saveAlways;
      var clone_element = Object.assign({}, element);
      clone_element.id =  _UUID["default"].uuid();
      if (clone_element.field_name){
        var field_name_array = clone_element.field_name.split('_');
        field_name_array.splice(-1, 1);
        clone_element.field_name = field_name_array.join('_') + '_' + _UUID["default"].uuid();
      }
      if (clone_element.options){
        var clone_options = [];
        for (var index = 0; index < clone_element.options.length; index++){
          var clone_option = Object.assign({}, clone_element.options[index]);
          var key_array = clone_option.key.split('_');
          key_array.splice(-1, 1);
          clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
          clone_options.push(clone_option);
        }
        clone_element.options = clone_options;
      }

      if (clone_element.table_options){
        var clone_options_1 = [];
        for (var i = 0; i < clone_element.table_options.length; i++){
          var clone_options_2 = [];
          for (var j = 0; j < clone_element.table_options[i].length; j++){
            var clone_option= Object.assign({}, clone_element.table_options[i][j]);
            var key_array = clone_option.key.split('_');
            key_array.splice(-1, 1);
            clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
            clone_options_2.push(clone_option);
          }
          clone_options_1.push(clone_options_2);
        }
        clone_element.table_options = clone_options_1;
      }

      if (clone_element.table_rows){
        clone_element.table_rows = [].concat(clone_element.table_rows)
      }
      if (clone_element.table_columns){
        clone_element.table_columns = [].concat(clone_element.table_columns)
      }

      if (clone_element.dropdown_options){
        var clone_options = [];
        for (var index = 0; index < clone_element.dropdown_options.length; index++){
          var clone_option = Object.assign({}, clone_element.dropdown_options[index]);
          var key_array = clone_option.key.split('_');
          key_array.splice(-1, 1);
          clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
          clone_options.push(clone_option);
        }
        clone_element.dropdown_options = clone_options;
      }

      data.splice(data.indexOf(element)+1, 0, clone_element);
      this.setData(context, data, saveAlways);
    },
    "cloneChild": function clone(context, _ref) {
      var _context$state = context.state,
          data = _context$state.data,
          saveAlways = _context$state.saveAlways;

      var clone_element = Object.assign({}, _ref.child);
      clone_element.id =  _UUID["default"].uuid();
      delete clone_element.col;
      delete clone_element.row;
      delete clone_element.parentId;
      delete clone_element.parentIndex;
      delete clone_element.parentType;

      if (clone_element.field_name){
        var field_name_array = clone_element.field_name.split('_');
        field_name_array.splice(-1, 1);
        clone_element.field_name = field_name_array.join('_') + '_' + _UUID["default"].uuid();
      }
      if (clone_element.options){
        var clone_options = [];
        for (var index = 0; index < clone_element.options.length; index++){
          var clone_option = Object.assign({}, clone_element.options[index]);
          var key_array = clone_option.key.split('_');
          key_array.splice(-1, 1);
          clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
          clone_options.push(clone_option);
        }
        clone_element.options = clone_options;
      }

      if (clone_element.table_options){
        var clone_options_1 = [];
        for (var i = 0; i < clone_element.table_options.length; i++){
          var clone_options_2 = [];
          for (var j = 0; j < clone_element.table_options[i].length; j++){
            var clone_option= Object.assign({}, clone_element.table_options[i][j]);
            var key_array = clone_option.key.split('_');
            key_array.splice(-1, 1);
            clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
            clone_options_2.push(clone_option);
          }
          clone_options_1.push(clone_options_2);
        }
        clone_element.table_options = clone_options_1;
      }

      if (clone_element.table_rows){
        clone_element.table_rows = [].concat(clone_element.table_rows)
      }
      if (clone_element.table_columns){
        clone_element.table_columns = [].concat(clone_element.table_columns)
      }

      if (clone_element.dropdown_options){
        var clone_options = [];
        for (var index = 0; index < clone_element.dropdown_options.length; index++){
          var clone_option = Object.assign({}, clone_element.dropdown_options[index]);
          var key_array = clone_option.key.split('_');
          key_array.splice(-1, 1);
          clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
          clone_options.push(clone_option);
        }
        clone_element.dropdown_options = clone_options;
      }

      data.splice(data.indexOf(_ref.parent)+1, 0, clone_element);
      this.setData(context, data, saveAlways);
    },
    "cloneParent": function clone(context, _ref) {
      var _context$state = context.state,
          data = _context$state.data,
          saveAlways = _context$state.saveAlways;

      var clone_parent = Object.assign({}, _ref.parent);
      var parent_id = _UUID["default"].uuid();
      var child_ids = []

      _ref.child.forEach(function (childs) {

        if (childs && Array.isArray(childs)) { // multi-stack feature
          var childRow= []
          childs.map(function (x) {
            var clone_child = Object.assign({}, x);
            var child_id = _UUID["default"].uuid();
            childRow.push(child_id);
  
            clone_child.id = child_id;
            clone_child.parentId = parent_id;
            clone_child.parentIndex += 1;
            if (clone_child.field_name){
              var field_name_array = clone_child.field_name.split('_');
              field_name_array.splice(-1, 1);
              clone_child.field_name = field_name_array.join('_') + '_' + _UUID["default"].uuid();
            }
            if (clone_child.options){
              var clone_options = [];
              for (var index = 0; index < clone_child.options.length; index++){
                var clone_option = Object.assign({}, clone_child.options[index]);
                var key_array = clone_option.key.split('_');
                key_array.splice(-1, 1);
                clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
                clone_options.push(clone_option);
              }
              clone_child.options = clone_options;
            }
            
            if (clone_child.table_options){
              var clone_options_1 = [];
              for (var i = 0; i < clone_child.table_options.length; i++){
                var clone_options_2 = [];
                for (var j = 0; j < clone_child.table_options[i].length; j++){
                  var clone_option= Object.assign({}, clone_child.table_options[i][j]);
                  var key_array = clone_option.key.split('_');
                  key_array.splice(-1, 1);
                  clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
                  clone_options_2.push(clone_option);
                }
                clone_options_1.push(clone_options_2);
              }
              clone_child.table_options = clone_options_1;
            }

            if (clone_child.table_rows){
              clone_child.table_rows = [].concat(clone_child.table_rows)
            }
            if (clone_child.table_columns){
              clone_child.table_columns = [].concat(clone_child.table_columns)
            }
      
            if (clone_child.dropdown_options){
              var clone_options = [];
              for (var index = 0; index < clone_child.dropdown_options.length; index++){
                var clone_option = Object.assign({}, clone_child.dropdown_options[index]);
                var key_array = clone_option.key.split('_');
                key_array.splice(-1, 1);
                clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
                clone_options.push(clone_option);
              }
              clone_child.dropdown_options = clone_options;
            }

            data.splice(data.indexOf(x)+1, 0, clone_child);
          })
          if (childRow.length > 0){
            child_ids.push(childRow);
          } else {
            child_ids.push(null);
          }
        } else {
          if (childs !== null){
            var x = childs;
            var clone_child = Object.assign({}, x);
            var child_id = _UUID["default"].uuid();
            child_ids.push(child_id);
  
            clone_child.id = child_id;
            clone_child.parentId = parent_id;
            clone_child.parentIndex += 1;
            if (clone_child.field_name){
              var field_name_array = clone_child.field_name.split('_');
              field_name_array.splice(-1, 1);
              clone_child.field_name = field_name_array.join('_') + '_' + _UUID["default"].uuid();
            }
            if (clone_child.options){
              var clone_options = [];
              for (var index = 0; index < clone_child.options.length; index++){
                var clone_option = Object.assign({}, clone_child.options[index]);
                var key_array = clone_option.key.split('_');
                key_array.splice(-1, 1);
                clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
                clone_options.push(clone_option);
              }
              clone_child.options = clone_options;
            }

            if (clone_child.table_options){
              var clone_options_1 = [];
              for (var i = 0; i < clone_child.table_options.length; i++){
                var clone_options_2 = [];
                for (var j = 0; j < clone_child.table_options[i].length; j++){
                  var clone_option= Object.assign({}, clone_child.table_options[i][j]);
                  var key_array = clone_option.key.split('_');
                  key_array.splice(-1, 1);
                  clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
                  clone_options_2.push(clone_option);
                }
                clone_options_1.push(clone_options_2);
              }
              clone_child.table_options = clone_options_1;
            }

            if (clone_child.table_rows){
              clone_child.table_rows = [].concat(clone_child.table_rows)
            }
            if (clone_child.table_columns){
              clone_child.table_columns = [].concat(clone_child.table_columns)
            }
      
            if (clone_child.dropdown_options){
              var clone_options = [];
              for (var index = 0; index < clone_child.dropdown_options.length; index++){
                var clone_option = Object.assign({}, clone_child.dropdown_options[index]);
                var key_array = clone_option.key.split('_');
                key_array.splice(-1, 1);
                clone_option.key = key_array.join('_') + '_' + _UUID["default"].uuid();
                clone_options.push(clone_option);
              }
              clone_child.dropdown_options = clone_options;
            }

            data.splice(data.indexOf(x)+1, 0, clone_child);
          } else {
            child_ids.push(null);
          }
        }
      });

      clone_parent.id = parent_id;
      clone_parent.childItems = child_ids;

      if (clone_parent.field_name){
        var field_name_array = clone_parent.field_name.split('_');
        field_name_array.splice(-1, 1);
        clone_parent.field_name = field_name_array.join('_') + '_' + _UUID["default"].uuid();
      }
      data.splice(data.indexOf(_ref.parent)+1, 0, clone_parent);
      this.setData(context, data, saveAlways);
    },
    post: function post(context) {
      var data = context.state.data;
      this.setData(context, data, true);
    },
    updateOrder: function updateOrder(context, elements) {
      var saveAlways = context.state.saveAlways;
      var newData = elements.filter(function (x) {
        return x && !x.parentId;
      });
      elements.filter(function (x) {
        return x && x.parentId;
      }).forEach(function (x) {
        return newData.push(x);
      });
      this.setData(context, newData, saveAlways);
    },
    save: function save(data) {
      if (_onPost) {
        _onPost({
          task_data: data
        });
      } else if (_saveUrl) {
        (0, _requests.post)(_saveUrl, {
          task_data: data
        });
      }
    }
  },
  mutations: {
    setData: function setData(state, payload) {
      // eslint-disable-next-line no-param-reassign
      state.data = payload;
      return state;
    },
    setSaveAlways: function setSaveAlways(state, payload) {
      // eslint-disable-next-line no-param-reassign
      state.saveAlways = payload;
      return state;
    }
  },
  initialState: {
    data: [],
    saveAlways: true
  }
});

store.setExternalHandler = function (onLoad, onPost) {
  _onLoad = onLoad;
  _onPost = onPost;
};

var _default = store;
exports["default"] = _default;